import * as Yup from 'yup';
import { PlantillaTurnoFormModel } from './PlantillaTurnoFormModel';

const {
    formField: {
        name,
        startTime,
        endTime,
        durationHours,
        position
    }
} = PlantillaTurnoFormModel;

export const validationSchema = Yup.object().shape({
    [name.name]: Yup.string().required(name.requiredErrorMsg),
    [position.name]: Yup.object().shape({
        value: Yup.string().required(),
        label: Yup.string().required()
    }).default(undefined).required(`${position.requiredErrorMsg}`),
    [startTime.name]: Yup.string().required(startTime.requiredErrorMsg),
    [endTime.name]: Yup.string().required(endTime.requiredErrorMsg),
    [durationHours.name]: Yup.number()
        .typeError('Debe ser un número')
        .required(durationHours.requiredErrorMsg)
        .min(0.1, 'Debe ser mayor a 0'),
});
